import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import { UserContext } from "../context/user.context";
import {
  getCourseRegistrationByUser,
  getUserCourseRole,
} from "../services/course.service";
export function useRole() {
  const { id } = useParams();
  const { user } = useContext(UserContext);
  const { data: staffCourseStatus } = useQuery({
    queryKey: [`staff-courses-${id}-${user?.id}`],
    enabled: !!(id && user?.id),
    queryFn: () =>
      getUserCourseRole({
        userId: Number(user?.id),
        courseId: Number(id ?? 0),
      }),
  });

  const { data: registration } = useQuery({
    queryKey: [`course-${id}-status-registration`],
    queryFn: () => getCourseRegistrationByUser(id!, user?.id!),
    enabled: !!user?.id && !!id && user.role === "student",
  });

  const role = String(user?.role).toLowerCase();
  const isStaff = ["staff", "admin", "super-admin"].includes(role);
  const isAdmin = ["admin", "super-admin"].includes(role);
  const isProctor = role === "proctor";
  // Directors see what admins see but can change nothing except their own
  // account. isAdmin/isStaff stay false for them, so edit controls gated on
  // those remain hidden; use canViewAll for visibility-only checks.
  const isDirector = role === "director";
  const canViewAll = isAdmin || isDirector;
  const registrationType = registration?.courseCost?.registrationType ?? "";

  return {
    user,
    isSuperAdmin: role === "super-admin",
    isStaff,
    isAdmin,
    isProctor,
    isDirector,
    canViewAll,
    isReadOnly: isDirector,
    isStudent: role === "student",
    isCourseStaff: !!staffCourseStatus,
    isCourseCoordinator: staffCourseStatus?.role === "CO",
    isCourseTeacherAssistant: staffCourseStatus?.role === "TA",
    userCourseRole: staffCourseStatus,
    isInstructor: staffCourseStatus?.role === "IN",
    isAuditStudent: registrationType === "Audit",
    isWebcastStudent: registrationType === "Webcast",
    isInClassStudent: registrationType === "In Class",
    isInWebcastAuditStudent: registrationType === "Webcast: Audit",
  };
}
